import { createSlice } from "@reduxjs/toolkit";
import {
  getNotifications,
  markNotificationRead,
  markAllNotificationsRead,
} from "./notificationsActions";

const initialState = {
  loading: false,
  items: [],
  meta: null,
  error: null,
  markAllReadLoading: false,
};

const notificationsSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    clearNotifications: () => initialState,
    incrementUnreadCount: (state) => {
      if (state.meta) {
        state.meta.unread_count = (state.meta.unread_count || 0) + 1;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      // getNotifications
      .addCase(getNotifications.pending, (state) => {
        state.loading = true;
      })
      .addCase(getNotifications.fulfilled, (state, action) => {
        state.items = action.payload.results || [];
        state.meta = action.payload.meta || null;
        state.loading = false;
      })
      .addCase(getNotifications.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      })
      // markNotificationRead — optimistic update
      .addCase(markNotificationRead.pending, (state, action) => {
        const { id, is_read } = action.meta.arg;
        const item = state.items.find((n) => n.id === id);
        if (item) {
          item._prev_is_read = item.is_read;
          item.is_read = is_read;
          if (state.meta) {
            if (is_read && !item._prev_is_read) {
              state.meta.unread_count = Math.max(0, (state.meta.unread_count || 0) - 1);
            } else if (!is_read && item._prev_is_read) {
              state.meta.unread_count = (state.meta.unread_count || 0) + 1;
            }
          }
        }
      })
      .addCase(markNotificationRead.fulfilled, (state, action) => {
        const item = state.items.find((n) => n.id === action.payload.id);
        if (item) {
          delete item._prev_is_read;
        }
      })
      .addCase(markNotificationRead.rejected, (state, action) => {
        const { id } = action.meta.arg;
        const item = state.items.find((n) => n.id === id);
        if (item && item._prev_is_read !== undefined) {
          if (item._prev_is_read !== item.is_read) {
            if (state.meta) {
              if (item.is_read) {
                state.meta.unread_count = (state.meta.unread_count || 0) + 1;
              } else {
                state.meta.unread_count = Math.max(0, (state.meta.unread_count || 0) - 1);
              }
            }
          }
          item.is_read = item._prev_is_read;
          delete item._prev_is_read;
        }
        state.error = action.payload;
      })
      // markAllNotificationsRead
      .addCase(markAllNotificationsRead.pending, (state) => {
        state.markAllReadLoading = true;
      })
      .addCase(markAllNotificationsRead.fulfilled, (state) => {
        state.items = state.items.map((item) => ({ ...item, is_read: true }));
        if (state.meta) {
          state.meta.unread_count = 0;
        }
        state.markAllReadLoading = false;
      })
      .addCase(markAllNotificationsRead.rejected, (state, action) => {
        state.error = action.payload;
        state.markAllReadLoading = false;
      });
  },
});

export const { clearNotifications, incrementUnreadCount } = notificationsSlice.actions;
export default notificationsSlice.reducer;
